export async function callAI(
  system: string,
  messages: { role: string; content: string }[]
): Promise<string> {
  const ai = (globalThis as any).AI
  if (!ai) return 'Call +251 99 774 5317'
  try {
    const r = await ai.run(
      '@cf/meta/llama-3.1-8b-instruct',
      {
        messages: [
          { role: 'system', content: system },
          ...messages
        ]
      }
    )
    return r.response ?? ''
  } catch {
    return 'Call +251 99 774 5317'
  }
}

export const ASHU_SYSTEM_PROMPT = `You are Ashu, the friendly AI assistant for Ashu Cleaning Service in Addis Ababa.
Phone: +251 99 774 5317. Call to book.
Services: Home Deep Clean, Sofa Washing, Mattress, Office, Post-Construction, Windows, Holiday Package, Sanitization.
All Addis Ababa neighborhoods.
Warm, bilingual Amharic+English. Emojis ok.
Under 120 words.`
